import { useState } from 'react';
import { Modal, Box } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBoxOpen, faTimes } from '@fortawesome/free-solid-svg-icons';
import { useTranslation } from 'react-i18next';
import ProductsPreviewList from './ProductsPreviewList.js';
import './knowledgeModal.css';
import './ProductsPreviewModal.css';

// Preview of a product catalog — opens from the products list "View" button,
// mirroring the website KnowledgeModal style. The list itself is the shared
// ProductsPreviewList (also embedded inline in the Products page source cards).
const ProductsPreviewModal = ({ open, onClose, botId, knowledgeId, filename }) => {
  const { t } = useTranslation();
  const [total, setTotal] = useState(0);

  return (
    <Modal open={open} onClose={onClose} aria-labelledby="products-preview-title">
      <Box
        sx={{
          position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)',
          width: '70%', maxWidth: '720px', maxHeight: '82%', bgcolor: 'background.paper',
          boxShadow: 24, p: 4, overflow: 'hidden', borderRadius: '10px', outline: 'none',
          display: 'flex', flexDirection: 'column',
        }}
      >
        <div className="knowledge-modal-header">
          <h2 className="knowledge-modal-header-title">
            <FontAwesomeIcon icon={faBoxOpen} className="knowledge-modal-type-icon" />
            {filename || t('products')}
            {total > 0 && <span className="pp-count">{total} {t('products').toLowerCase()}</span>}
          </h2>
          <button className="knowledge-modal-close" onClick={onClose}>
            <FontAwesomeIcon icon={faTimes} />
          </button>
        </div>
        {open && <ProductsPreviewList botId={botId} knowledgeId={knowledgeId} onTotal={setTotal} />}
      </Box>
    </Modal>
  );
};

export default ProductsPreviewModal;
